import React, { Fragment, useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { translate } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import * as _ from 'lodash';
import DataGridGroupBond from '../../../table/DataGridGroupBond';
import DatagridHeaderBond from '../../../table/DataGridHeaderBond';

function TblTP({ t, partSnap, typeIndex }) {
  const [isPc, setIsPc] = useState(false);
  const [heightTb, setHeightTb] = useState(360);

  useEffect(() => {
    const heightTb = 360 - (typeIndex === 1 ? 0 : typeIndex === 2 ? 100 : 145);
    setHeightTb(heightTb);
  }, [typeIndex]);

  return (
    <Fragment>
      <div className="tbl-fix-header">
        <table className="table table-bordered table-fix">
          <colgroup>
            <col width="6%" />
            <col width="2.5%" />
            <col width="2.5%" />
            <col width="2.5%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.0%" />
            <col width="3.3%" />
            <col width="3%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.5%" />
            <col width="3.2%" />
            <col width="3.2%" />
            <col width="3.1%" />
            <col width="3.1%" />
            <col width="4.2%" />
            {/** nn mua */}
            <col width="3.5%"></col>
            {/** nn ban */}
            <col width="3.9%"></col>
          </colgroup>
          <thead className="bb-1-haft ">
            <DatagridHeaderBond isPc={isPc} setIsPc={setIsPc} t={t} />
          </thead>
        </table>
      </div>
      {!isMobile && (
        <PerfectScrollbar style={{ height: `calc(100vh - ${heightTb}px)` }}>
          <DataGridGroupBond
            isPc={isPc}
            resource={partSnap}
            className="table table-bordered table-fix"
          />
        </PerfectScrollbar>
      )}
      {isMobile && (
        <div
          style={{
            width: '100%',
            height: `calc(100vh - ${heightTb}px)`,
            overflowY: 'auto',
          }}
        >
          <DataGridGroupBond
            isPc={isPc}
            resource={partSnap}
            className="table table-bordered table-fix"
          />
        </div>
      )}
    </Fragment>
  );
}

export default translate('translations')(TblTP);
